import {computed, observable, makeObservable} from "mobx";
import {BookmakerViewModel} from "../../bookmaker/models/bookmaker-view-model";
import {RateOptionViewModel} from "../rate-option/models/rate-option.view-model";
import {OddsDomainModel} from "./odds.domain-model";
import {BaseViewModel} from "../../../../infrastructure/models/base-view-model";
import {RateOptionDomainModel} from "../rate-option/models/rate-option.domain-model";
import {ODDS_TYPES} from "../../../../core/components/odds/components/odds-consts";
import {EXTRA_LINKS_CONTEXTS} from "../../../../core/app/consts";
import {ExtraLinkDomainModel} from "../extra-link/models/extra-link.domain-model";
import {LineTypeViewModel} from "../line-type/line-type.view-model";

export class OddsViewModel extends BaseViewModel {
  domainModel: OddsDomainModel;
  @observable oddsType: ODDS_TYPES;
  context: EXTRA_LINKS_CONTEXTS;

  constructor(domainModel: OddsDomainModel, oddsType: ODDS_TYPES, context: EXTRA_LINKS_CONTEXTS){
    super(domainModel);

    this.domainModel = domainModel;
    this.oddsType = oddsType;
    this.context = context;
    
    makeObservable(this);
  }

  get bookmaker(): BookmakerViewModel {
    const bookmakerViewModel: BookmakerViewModel = new BookmakerViewModel(this.domainModel.bookmaker);

    return bookmakerViewModel;
  }

  @computed get rateOptions(): Array<RateOptionViewModel> {
    const rateOptions: Array<RateOptionViewModel> = this.domainModel.options?.map((rate: RateOptionDomainModel) => new RateOptionViewModel(rate, this.oddsType, this.domainModel.options.length, this.context));

    return rateOptions;
  }

  get gameId(): Number {
    return this.domainModel.gameId
  }

  get link(): String {
    let extraLink: ExtraLinkDomainModel = this.domainModel.extraLinks?.find((extraLink: ExtraLinkDomainModel) => extraLink.context === this.context);

    return extraLink?.link || this.domainModel.link;
  }

  get lineTypeId(): Number {
    return this.domainModel.lineTypeId
  }

  get lineType(): LineTypeViewModel {
    const lineType: LineTypeViewModel = new LineTypeViewModel(this.domainModel.lineType);

    return lineType;
  }

  @computed get isValidCurrentRateOptions(): Boolean {
    let isValidRateOptions: Boolean = this.rateOptions?.some(rate => rate.isCurrentRateValid);

    return isValidRateOptions;
  }

  @computed get isSingleOdd(): Boolean {
    return this.rateOptions?.length === 1
  }
}
